"use strict";

module.exports = require("./Instagram.js");